import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';
import store from '@/store/index';
import {Characteristic, ValueDefinition} from "@/configurator/types";

// BLINDSTOCK ALLES

// CUST_MM_BLINDSTOCK_S_ANZ
// KTU_MM_BLINDSTOCK_S_BREITE
// KTU_MM_BLINDSTOCK_S_HOEHE
// KTU_MM_BLINDSTOCK_S_LAENGE
// CUST_MM_BLINDSTOCK_W_ANZ
// KTU_MM_BLINDSTOCK_W_BREITE
// KTU_MM_BLINDSTOCK_W_HOEHE
// KTU_MM_BLINDSTOCK_W_LAENGE
export const calculateALLESBLINDSTOCK = (): any => {
    const result: any = {
        blindstock_S_Anz: 0,
        blindstock_S_Breite: 0,
        blindstock_S_Hoehe: 0,
        blindstock_S_Laenge: 0,
        blindstock_W_Anz: 0,
        blindstock_W_Breite: 0,
        blindstock_W_Hoehe: 0,
        blindstock_W_Laenge: 0,
    };

    const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Functions);
    const frameHeightFront = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_HOEHE_BS', contex.Measure);
    const frameHeightBack = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_HOEHE_GBS', contex.Measure);
    const frameWidth = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_BREITE', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = wallWidth - 13;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 32;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = wallWidth - 13;
                            result.blindstock_W_Laenge = frameWidth + 64;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = wallWidth;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 32;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = wallWidth - 13;
                            result.blindstock_W_Laenge = frameWidth + 64;
                            break;
                        case 'ES':
                        case 'EB':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = 40;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 32;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = 40;
                            result.blindstock_W_Laenge = frameWidth + 64;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = 50;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 32;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = 50;
                            result.blindstock_W_Laenge = frameWidth + 64;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = wallWidth;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 42;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = wallWidth;
                            result.blindstock_W_Laenge = frameWidth + 84;
                            break;
                        case 'ES':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = 52;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 42;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = 52;
                            result.blindstock_W_Laenge = frameWidth + 84;
                            break;
                        case 'EB':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = 40;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 42;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = 40;
                            result.blindstock_W_Laenge = frameWidth + 84;
                            break;
                        case 'ES-SV2':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = 64;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 42;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = 64;
                            result.blindstock_W_Laenge = frameWidth + 84;
                            break;
                        case 'EB-SV2':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 20;
                            result.blindstock_S_Breite = 50;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 42;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 20;
                            result.blindstock_W_Breite = 50;
                            result.blindstock_W_Laenge = frameWidth + 84;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 40;
                            result.blindstock_S_Breite = wallWidth - 13;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 51;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 40;
                            result.blindstock_W_Breite = wallWidth - 13;
                            result.blindstock_W_Laenge = frameWidth + 102;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 40;
                            result.blindstock_S_Breite = wallWidth;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 51;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 40;
                            result.blindstock_W_Breite = wallWidth;
                            result.blindstock_W_Laenge = frameWidth + 102;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 40;
                            result.blindstock_S_Breite = wallWidth;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 51;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 40;
                            result.blindstock_W_Breite = wallWidth;
                            result.blindstock_W_Laenge = frameWidth + 102;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 40;
                            result.blindstock_S_Breite = wallWidth;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 61;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 40;
                            result.blindstock_W_Breite = wallWidth;
                            result.blindstock_W_Laenge = frameWidth + 122;
                            break;
                        case 'ES-SV2':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 40;
                            result.blindstock_S_Breite = 64;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 61;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 40;
                            result.blindstock_W_Breite = wallWidth - 64;
                            result.blindstock_W_Laenge = frameWidth + 122;
                            break;
                        case 'EB-SV2':
                            result.blindstock_S_Anz = 2;
                            result.blindstock_S_Hoehe = 40;
                            result.blindstock_S_Breite = 50;
                            result.blindstock_S_Laenge = Math.max(frameHeightFront, frameHeightBack) + 61;
                            result.blindstock_W_Anz = 1;
                            result.blindstock_W_Hoehe = 40;
                            result.blindstock_W_Breite = 50;
                            result.blindstock_W_Laenge = frameWidth + 122;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result.blindstock_S_Anz = 0;
            result.blindstock_S_Hoehe = 0;
            result.blindstock_S_Breite = 0;
            result.blindstock_S_Laenge = 0;
            result.blindstock_W_Anz = 0;
            result.blindstock_W_Hoehe = 0;
            result.blindstock_W_Breite = 0;
            result.blindstock_W_Laenge = 0;
            break;
        default:
            break;
    }

    return result;
};


// *** BLINDSTOCK Calculations are implemented in calculateALLESBLINDSTOCK method in BlindstockMultiplexCharacteristics.ts as one formula.
// *** Below are the separated formulas not called anywhere in code

// KTU_MM_BLINDSTOCK_S_BREITE
export const calculateBLINDSTOCKSBREITE = () => {
    let result: number = 0;

    const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = wallWidth - 13;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES':
                        case 'EB':
                            result = 40;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = 50;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES':
                            result = 52;
                            break;
                        case 'EB':
                            result = 40;
                            break;
                        case 'ES-SV2':
                            result = 64;
                            break;
                        case 'EB-SV2':
                            result = 50;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = wallWidth - 13;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = wallWidth;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES-SV2':
                            result = 64;
                            break;
                        case 'EB-SV2':
                            result = 50;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result = 0;
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_BLINDSTOCK_S_HOEHE
export const calculateBLINDSTOCKSHOEHE = () => {
    let result: number = 0;

    // const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = 20;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 20;
                            break;
                        case 'ES':
                        case 'EB':
                            result = 20;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = 20;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 20;
                            break;
                        case 'ES':
                            result = 20;
                            break;
                        case 'EB':
                            result = 20;
                            break;
                        case 'ES-SV2':
                            result = 20;
                            break;
                        case 'EB-SV2':
                            result = 20;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = 40;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 40;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 40;
                            break;
                        case 'ES-SV2':
                            result = 40;
                            break;
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result = 0;
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_BLINDSTOCK_S_LAENGE
export const calculateBLINDSTOCKSLAENGE = () => {
    let result: number = 0;

    const frameHeightFront = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_HOEHE_BS', contex.Measure);
    const frameHeightBack = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_HOEHE_GBS', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = Math.max(frameHeightFront, frameHeightBack) + 32;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = Math.max(frameHeightFront, frameHeightBack) + 32;
                            break;
                        case 'ES':
                        case 'EB':
                            result = Math.max(frameHeightFront, frameHeightBack) + 32;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = Math.max(frameHeightFront, frameHeightBack) + 32;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = Math.max(frameHeightFront, frameHeightBack) + 42;
                            break;
                        case 'ES':
                            result = Math.max(frameHeightFront, frameHeightBack) + 42;
                            break;
                        case 'EB':
                            result = Math.max(frameHeightFront, frameHeightBack) + 42;
                            break;
                        case 'ES-SV2':
                            result = Math.max(frameHeightFront, frameHeightBack) + 42;
                            break;
                        case 'EB-SV2':
                            result = Math.max(frameHeightFront, frameHeightBack) + 42;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = Math.max(frameHeightFront, frameHeightBack) + 51;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = Math.max(frameHeightFront, frameHeightBack) + 51;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = Math.max(frameHeightFront, frameHeightBack) + 51;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = Math.max(frameHeightFront, frameHeightBack) + 61;
                            break;
                        case 'ES-SV2':
                            result = Math.max(frameHeightFront, frameHeightBack) + 61;
                            break;
                        case 'EB-SV2':
                            result = Math.max(frameHeightFront, frameHeightBack) + 61;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result = 0;
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_BLINDSTOCK_W_BREITE
export const calculateBLINDSTOCKWBREITE = () => {
    let result: number = 0;

    const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = wallWidth - 13;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES':
                        case 'EB':
                            result = 40;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = 50;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES':
                            result = 52;
                            break;
                        case 'EB':
                            result = 40;
                            break;
                        case 'ES-SV2':
                            result = 64;
                            break;
                        case 'EB-SV2':
                            result = 50;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = wallWidth - 13;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = wallWidth;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallWidth;
                            break;
                        case 'ES-SV2':
                            result = 64;
                            break;
                        case 'EB-SV2':
                            result = 50;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result = 0;
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_BLINDSTOCK_W_HOEHE
export const calculateBLINDSTOCKWHOEHE = () => {
    let result: number = 0;

    // const wallWidth = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = 20;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 20;
                            break;
                        case 'ES':
                        case 'EB':
                            result = 20;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = 20;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 20;
                            break;
                        case 'ES':
                            result = 20;
                            break;
                        case 'EB':
                            result = 20;
                            break;
                        case 'ES-SV2':
                            result = 20;
                            break;
                        case 'EB-SV2':
                            result = 20;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = 40;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 40;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = 40;
                            break;
                        case 'ES-SV2':
                            result = 40;
                            break;
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result = 0;
            break;
        default:
            break;
    }

    return result;
};

// KTU_MM_BLINDSTOCK_W_LAENGE
export const calculateBLINDSTOCKWLAENGE = () => {
    let result: number = 0;

    const frameWidth = helper.GetMainCharacteristicValue('KTU_MM_ZARGEN_BREITE', contex.Measure);

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const frameForm = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = frameWidth + 64;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = frameWidth + 64;
                            break;
                        case 'ES':
                        case 'EB':
                            result = frameWidth + 64;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = frameWidth + 64;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'UB':
                        case 'UBS':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = frameWidth + 84;
                            break;
                        case 'ES':
                            result = frameWidth + 84;
                            break;
                        case 'EB':
                            result = frameWidth + 84;
                            break;
                        case 'ES-SV2':
                            result = frameWidth + 84;
                            break;
                        case 'EB-SV2':
                            result = frameWidth + 84;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '0':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = frameWidth + 102;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = frameWidth + 102;
                            break;
                        case 'ES-SV2':
                        case 'EB-SV2':
                            result = frameWidth + 102;
                            break;
                        default:
                            break;
                    }
                    break;
                case '30':
                    switch (frameForm) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = frameWidth + 122;
                            break;
                        case 'ES-SV2':
                            result = frameWidth + 122;
                            break;
                        case 'EB-SV2':
                            result = frameWidth + 122;
                            break;
                        default:
                            break;
                    }
                    break;
            }
            break;
        case '5':
        case '6':
        case '7':
            result = 0;
            break;
        default:
            break;
    }

    return result;
};

//KTU_MM_BLINDSTOCK
export const getBlindstockLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const framModel = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);

    if (wallType === '1' ) {
        if(fireResistance === '30') {
            if(framModel === 'US') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'ES') {
                lltNumber = 'LLT800053';
            }
            else if(framModel === 'EB') {
                lltNumber = 'LLT800054';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800057';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800058';
            }
        }
        else if(fireResistance === '0') {
            if(framModel === 'US') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'ES') {
                lltNumber = 'LLT800051';
            }
            else if(framModel === 'EB') {
                lltNumber = 'LLT800052';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800055';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800056';
            }
        }
    }
    else if (wallType === '2' ) {
        if(fireResistance === '30') {
            if(framModel === 'US') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'ES') {
                lltNumber = 'LLT800053';
            }
            else if(framModel === 'EB') {
                lltNumber = 'LLT800054';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800057';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800058';
            }
        }
        else if(fireResistance === '0') {
            if(framModel === 'US') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'ES') {
                lltNumber = 'LLT800051';
            }
            else if(framModel === 'EB') {
                lltNumber = 'LLT800052';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800055';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800056';
            }
        }
    }
    else if (wallType === '3' ) {
        if(fireResistance === '30') {
            if(framModel === 'US') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'ES') {
                lltNumber = 'LLT800053';
            }
            else if(framModel === 'EB') {
                lltNumber = 'LLT800054';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800045';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800047';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800057';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800058';
            }
        }
        else if(fireResistance === '0') {
            if(framModel === 'US') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES') {
                lltNumber = 'LLT800051';
            }
            else if(framModel === 'EB') {
                lltNumber = 'LLT800052';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800037';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800039';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800055';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800056';
            }
        }
    }
    else if (wallType === '4' ) {
        if(fireResistance === '30') {
            if(framModel === 'US') {
                lltNumber = 'LLT800048';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800050';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800048';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800050';
            }
            else if(framModel === 'ES') {
                lltNumber = 'NEIN';
            }
            else if(framModel === 'EB') {
                lltNumber = 'NEIN';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800048';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800050';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800048';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800050';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800061';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800062';
            }
        }
        else if(fireResistance === '0') {
            if(framModel === 'US') {
                lltNumber = 'LLT800040';
            }
            else if(framModel === 'UB') {
                lltNumber = 'LLT800044';
            }
            else if(framModel === 'UBS') {
                lltNumber = 'LLT800040';
            }
            else if(framModel === 'USB') {
                lltNumber = 'LLT800044';
            }
            else if(framModel === 'ES') {
                lltNumber = 'NEIN';
            }
            else if(framModel === 'EB') {
                lltNumber = 'NEIN';
            }
            else if(framModel === 'ES-SST') {
                lltNumber = 'LLT800040';
            }
            else if(framModel === 'EB-SST') {
                lltNumber = 'LLT800044';
            }
            else if(framModel === 'ES-SV1') {
                lltNumber = 'LLT800040';
            }
            else if(framModel === 'EB-SV1') {
                lltNumber = 'LLT800044';
            }
            else if(framModel === 'ES-SV2') {
                lltNumber = 'LLT800059';
            }
            else if(framModel === 'EB-SV2') {
                lltNumber = 'LLT800060';
            }
        }
    }
    else if (wallType === '5' ) {
        if(fireResistance === '30') {
            lltNumber = 'NEIN';
        }
        else if(fireResistance === '0') {
            lltNumber = 'NEIN';
        }
    }
    else if (wallType === '6' ) {
        if(fireResistance === '30') {
            lltNumber = 'NEIN';
        }
        else if(fireResistance === '0') {
            lltNumber = 'NEIN';
        }
    }
    else if (wallType === '7' ) {
        if(fireResistance === '30') {
            lltNumber = 'NEIN';
        }
        else if(fireResistance === '0') {
            lltNumber = 'NEIN';
        }
    }

    const blindstockCharacteristic  = store.state.frameModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_BLINDSTOCK')[0];
    const blindstockCharacteristicValue: ValueDefinition = blindstockCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return blindstockCharacteristicValue;
};
